<template>
  <div style="margin-bottom: 50px">
    <br />
    <h4 style="
        margin-top: 0px;
        margin-bottom: 30px;
        color: #ff5f00;
        font-weight: bold;
        font-size: 15px;
      ">
      REPORTE RIESGOS MATERIALES Y NO MATERIALES CON MAYOR PRESENCIA, POR
      GERENCIA GENERAL
    </h4>
    <center v-if="loading">
      <br />
      <br />
      <Circle9 style="margin-bottom: 8px"></Circle9>
      <small>Cargando Datos ...</small>
      <br />
      <br />
    </center>
    <el-row v-if="!loading" :gutter="20">
      <el-col :sm="24">
        <el-alert style="margin-bottom: 30px; color: black;" type="info" show-icon :closable="false">En este Reporte se
          muestran los riesgos materiales y no materiales
          que más se repiten en los inventarios por gerencia general.</el-alert>
      </el-col>
      <el-col :sm="4">
        <span style="font-size: 14px">Seleccione Faena</span><br />
        <el-select @change="setData" v-model="faena_selected" style="margin-top: 10px; width: 100%;"
          placeholder="Seleccione Faena">
          <el-option v-for="item in listadoFaenas" :key="item.faena_id" :label="item.nombre"
            :value="item.faena_id"></el-option>
        </el-select>
      </el-col>
      <el-col :sm="4">
        <span style="font-size: 14px">Tipo de contrato</span><br />
        <el-select style="margin-top: 10px; width: 100%;" v-model="type" placeholder="Seleccione una opción" @change="setData">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <br /><br /><br />
      </el-col>
    </el-row>
    <el-row v-if="!loading" v-for="(item, index) in arbol.operaciones" :key="index" style="margin-bottom: 20px">
      <el-col :sm="15">
        <div style="font-size: 13px; margin-bottom: 7px; font-weight: bold">
          RIESGOS MATERIALES
        </div>
        <table border="1" cellspacing="0">
          <tr>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              GERENCIA GENERAL
            </td>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              RIESGO MATERIAL REPETIDO
            </td>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              CANTIDAD
            </td>
          </tr>
          <tr v-if="item.materiales.length === 0">
            <td style="padding: 5px; font-size: 13px">{{ item.nombre }}</td>
            <td style="text-align: center; padding: 5px; font-size: 13px" colspan="2">
              SIN DATOS
            </td>
          </tr>
          <tr v-for="(material, i) in item.materiales" :key="`MA-${i}`">
            <td style="padding: 5px; font-size: 13px">{{ item.nombre }}</td>
            <td style="padding: 5px; font-size: 13px">
              {{ material.riesgo_name }}
            </td>
            <td style="padding: 5px; font-size: 13px; text-align: center">
              {{ material.count }}
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :sm="8">
        <apexchart v-if="item.materiales.length > 0" type="bar" height="350" :options="generateData(item.materiales)"
          :series="generateSerie(item.materiales)"></apexchart>
      </el-col>
      <el-col :sm="15">
        <br /><br />
        <div style="font-size: 13px; margin-bottom: 7px; font-weight: bold">
          RIESGOS NO MATERIALES
        </div>
        <table border="1" cellspacing="0">
          <tr>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              GERENCIA GENERAL
            </td>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              RIESGO NO MATERIAL REPETIDO
            </td>
            <td style="
                background-color: #808080;
                color: white;
                font-weight: bold;
                font-size: 13px;
                padding: 5px;
              ">
              CANTIDAD
            </td>
          </tr>
          <tr v-if="item.materiales.length === 0">
            <td style="padding: 5px; font-size: 13px">{{ item.nombre }}</td>
            <td style="text-align: center; padding: 5px; font-size: 13px" colspan="2">
              SIN DATOS
            </td>
          </tr>
          <tr v-for="(no_material, i) in item.no_materiales" :key="`MA-${i}`">
            <td style="padding: 5px; font-size: 13px">{{ item.nombre }}</td>
            <td style="padding: 5px; font-size: 13px">
              {{ no_material.riesgo_name }}
            </td>
            <td style="padding: 5px; font-size: 13px; text-align: center">
              {{ no_material.count }}
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :sm="8">
        <br /><br />
        <apexchart v-if="item.no_materiales.length > 0" type="bar" height="350"
          :options="generateData(item.no_materiales)" :series="generateSerie(item.no_materiales)"></apexchart>
      </el-col>
      <el-col :sm="24">
        <br />
        <hr v-if="arbol.operaciones[index + 1]" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { Circle9 } from "vue-loading-spinner";

export default {
  name: "reportWeek",
  data() {
    return {
      faena_selected: "",
      listadoFaenas: [
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
      type: "Propio",
      options: [
        {
          value: "Propio",
          label: "Propios",
        },
        {
          value: "Contratista",
          label: "Colaboradores",
        },
      ],
      chartData: {
        labels: ["Item 1", "Item 2", "Item 3"],
        datasets: [
          {
            label: "Cantidad",
            data: [10, 20, 30],
          },
        ],
      },
      arbol: [],
    };
  },
  async created() {
    this.faena_selected = localStorage.getItem("faena_dashboad");
    await this.setDataStatus(this.type);
  },
  components: {
    Circle9,
  },
  methods: {
    async setData() {
      await this.setDataStatus(this.type);
    },
    generateSerie(data) {
      var series = [];
      data
        .map((d) => ({ count: d.count, riesgo: d.riesgo_name }))
        .forEach((d) => {
          series.push({
            name: d.riesgo,
            data: [d.count],
          });
        });

      return series;
    },
    generateData(data) {
      var chartOptions = {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["#f44b00", "#546E7A", "#006b74"],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: data.map((d) => d.riesgo_name),
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        legend: {
          show: false,
        },
      };
      return chartOptions;
    },
    async setDataStatus(type) {
      this.loading = true;
      var response = await axios.get(
        `https://legacy.bhp.lifeon.cl/data-science/getModa/${this.faena_selected}/${type}`
      );
      if (response.data.length > 0) {
        this.arbol = response.data[0];
      }
      this.loading = false;
    },
  },
};
</script>
<style></style>
